"use strict";

var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createAsyncMiddleware;

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _attempt = _interopRequireDefault(require("lodash/attempt"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _isError = _interopRequireDefault(require("lodash/isError"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _isPromise = _interopRequireDefault(require("is-promise"));

var _errors = require("../errors");

var _validation = require("../validation");

var _utilities = require("../utilities");

var _RSAA = _interopRequireDefault(require("../constants/RSAA"));

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

function createAsyncMiddleware() {
  return function (store) {
    return function (next) {
      return function (action) {
        // Do not process actions without an [RSAA] property
        if (!(0, _validation.isRSAA)(action)) {
          return next(action);
        }

        return new _promise.default(function (resolve) {
          // Try to dispatch an error request FSA for invalid RSAAs
          var validationErrors = (0, _validation.validateRSAA)(action);

          if (validationErrors.length) {
            var _types = action[_RSAA.default].types;

            if ((0, _isArray.default)(_types)) {
              var _requestType = _types[0];

              if (_requestType && _requestType.type) {
                _requestType = _requestType.type;
              }

              next({
                type: _requestType,
                payload: new _errors.InvalidError(validationErrors),
                error: true
              });
            }

            resolve();
            return;
          } // Parse the validated RSAA action


          var getState = store.getState;
          var _action$RSAA = action[_RSAA.default],
              types = _action$RSAA.types,
              callAPI = _action$RSAA.callAPI,
              shouldCallAPI = _action$RSAA.shouldCallAPI;

          var _normalizeTypeDescrip = (0, _utilities.normalizeTypeDescriptors)(types),
              _normalizeTypeDescrip2 = (0, _slicedToArray2.default)(_normalizeTypeDescrip, 3),
              requestType = _normalizeTypeDescrip2[0],
              successType = _normalizeTypeDescrip2[1],
              failureType = _normalizeTypeDescrip2[2]; // Should we bail out?


          var bailout = (0, _attempt.default)(function () {
            return !(0, _isUndefined.default)(shouldCallAPI) && !(0, _utilities.resultWith)(shouldCallAPI, getState());
          });

          if ((0, _isError.default)(bailout)) {
            (0, _utilities.actionWith)(_objectSpread(_objectSpread({}, requestType), {}, {
              payload: new _errors.RequestError("\"[RSAA].shouldCallAPI\" function failed with \"".concat(bailout.message, "\".")),
              error: true
            }), getState()).then(function (requestAction) {
              resolve(next(requestAction));
            });
            return;
          }

          if (bailout) {
            resolve();
            return;
          }

          var promise = (0, _attempt.default)(function () {
            return callAPI(getState());
          }); // An error was thrown when calling the [RSAA].callAPI function.
          // Dispatch error request FSA and stop processing any futher operations.

          if ((0, _isError.default)(promise)) {
            (0, _utilities.actionWith)(_objectSpread(_objectSpread({}, requestType), {}, {
              payload: new _errors.RequestError("\"[RSAA].callAPI\" function failed with \"".concat(promise.message, "\".")),
              error: true
            })).then(function (requestAction) {
              resolve(next(requestAction));
            });
            return;
          } // An invalid value was returned when calling the [RSAA].callAPI function.
          // Dispatch error request FSA and stop processing any futher operations.


          if (!(0, _isPromise.default)(promise)) {
            (0, _utilities.actionWith)(_objectSpread(_objectSpread({}, requestType), {}, {
              payload: new _errors.RequestError("\"[RSAA].callAPI\" function must return a promise but returned a ".concat((0, _typeof2.default)(promise), " instead.")),
              error: true
            })).then(function (requestAction) {
              resolve(next(requestAction));
            });
            return;
          } // We can now dispatch the request FSA


          (0, _utilities.actionWith)(requestType, getState()).then(function (requestAction) {
            next(requestAction);
            promise.then(function (response) {
              if (response.ok) {
                (0, _utilities.actionWith)(successType, getState(), response).then(function (successAction) {
                  resolve(next(successAction));
                });
              } else {
                (0, _utilities.actionWith)(_objectSpread(_objectSpread({}, failureType), {}, {
                  error: true
                }), getState(), response).then(function (failureAction) {
                  resolve(next(failureAction));
                });
              }
            });
          });
        });
      };
    };
  };
}